"use strict";

Shopify.theme.jsTextSlider = {
  init: function init($section) {
    console.log("jsTextSlider");
    Shopify.theme.jsTextSlider = $.extend(this, Shopify.theme.getSectionData($section)); //Ensure product media libraries are present
    this.handleTextSlider($section);
  },
  handleTextSlider:function handleTextSlider($section)
  {
    var $textSlider = $section.find('.text-slider__wrapper');
    $textSlider.flickity({
       wrapAround: true,
       watchCss:true,
       contain: false,
       pageDots: false,
       prevNextButtons: false
    });
  },
  blockSelect:function blockSelect($section, id) {
    console.log(id);

  },
  unload: function unload($section) {

  }
};